import { $t } from '@/i18n';
import { notification } from 'ant-design-vue';
import { message } from '@/utils/wuji-message';
export class FormCallResult {
    items;
    type = 'success';
    message = '';
    get failDesc() {
        if (this.type === 'success') {
            return '';
        }
        const failureItems = this.items.filter(item => !item.succ);
        const desc = failureItems.map(item => $t('k_705a90ff', { arg_0: item.bizId, arg_1: item.message })).join(';\n');
        return desc;
    }
    constructor(items) {
        this.items = items;
        const successCount = items.filter(item => item.succ).length;
        if (successCount === items.length) {
            this.type = 'success';
            this.message = $t('k_953d8775');
            return;
        }
        if (successCount > 0 && successCount < items.length) {
            this.type = 'partial';
            this.message = $t('k_abda9ac5');
            return;
        }
        this.type = 'fail';
        this.message = $t('k_9ea11a90');
    }
    showMessage() {
        if (this.type === 'success') {
            message.success(this.message);
            return;
        }
        notification.open({
            message: this.message,
            description: this.failDesc,
        });
    }
}
